import { FingerprintjsProAngularService, FingerprintJSPro } from '@fingerprintjs/fingerprintjs-pro-angular';

import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FingerprintService {
    constructor(private fingerprintService: FingerprintjsProAngularService) {}

    async getVisitorData(): Promise<FingerprintJSPro.ExtendedGetResult | FingerprintJSPro.GetResult> {
        try {
            const data = await this.fingerprintService.getVisitorData({
                extendedResult: true
            });

            return data;
        } catch (error) {
            console.error('Fingerprint error:', error);
            throw error;
        }
    }

    private getSessionId(): string {
        return sessionStorage.getItem('sessionId') || 'anonymous';
    }

    private getUserId(): string | undefined {
        return localStorage.getItem('userId') || undefined;
    }
}
